import script from "./tagSelectorMaintenance.vue?vue&type=script&setup=true&lang=js"
export * from "./tagSelectorMaintenance.vue?vue&type=script&setup=true&lang=js"

import "./tagSelectorMaintenance.vue?vue&type=style&index=0&id=a74c864e&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a74c864e"]])

export default __exports__